export default __webpack_public_path__ + "static/media/wave-pages.57ac0772.svg";